const packageIncludesOptions = [
  { value: "Venue", label: "Venue" },
  { value: "Catering", label: "Catering" },
  { value: "Anchor", label: "Anchor" },
  { value: "Dhol", label: "Dhol" },
  { value: "LED Wall", label: "LED Wall" },
  { value: "Dance Troupe", label: "Dance Troupe" },
  { value: "Live Music Band", label: "Live Music Band" },
  { value: "Decoration", label: "Decoration" },
  { value: "Pre Rituals Decoration", label: "Pre Rituals Decoration" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "Photographer", label: "Photographer" },
  { value: "DJ", label: "DJ" },
  { value: "Choreographer", label: "Choreographer" },
  { value: "Entry Theme", label: "Entry Theme" },
  { value: "Makeup Artist", label: "Makeup Artist" },
  { value: "Mehndi Artist", label: "Mehndi Artist" },
  { value: "Magician", label: "Magician" },
  { value: "Pandit Ji", label: "Pandit Ji" },
  { value: "Brass Band", label: "Brass Band" },
  { value: "Single Troup DJ", label: "Single Troup DJ" },
  { value: "Vintage Car", label: "Vintage Car" },
  { value: "Bagghi", label: "Bagghi" },
  { value: "Fireworks", label: "Fireworks" },
  { value: "Return Gifts", label: "Return Gifts" },
  { value: "Event Planner", label: "Event Planner" },
  { value: "Transportation", label: "Transportation" },
  { value: "Security", label: "Security" },
  {
    value: "Lagan Geet Artist (Ritual Singer)",
    label: "Lagan Geet Artist (Ritual Singer)",
  },
];
const tandcOptions = [
  {
    value: "The package is subject to availability.",
    label: "The package is subject to availability.",
  },
  {
    value: "Customized packages are available.",
    label: "Customized packages are available.",
  },
  {
    value: "Additional vegetarian and non-vegetarian options are available.",
    label: "Additional vegetarian and non-vegetarian options are available.",
  },
  {
    value: "Any add-ons will incur additional charges.",
    label: "Any add-ons will incur additional charges.",
  },
  {
    value: "⁠Package prices may vary due to season and demand.",
    label: "⁠Package prices may vary due to season and demand.",
  },
  {
    value: "⁠Packages are available for a limited time only.",
    label: "⁠Packages are available for a limited time only.",
  },
  {
    value: "Decoration and entertainment are provided by third-party vendors",
    label: "Decoration and entertainment are provided by third-party vendors",
  },
  {
    value: "Diesel charges for the generator will be additional.",
    label: "Diesel charges for the generator will be additional.",
  },
];
const addOnsOption = [
  {
    value: "Anchor ( Basic & Professional)",
    label: "Anchor ( Basic & Professional)",
  },
  {
    value: "Punjabi Dhol Group - (4+1)",
    label: "Punjabi Dhol Group - (4+1)",
  },
  {
    value: "Live Music Band - Includes Singer (3+2)",
    label: "Live Music Band - Includes Singer (3+2)",
  },
  {
    value: "Sufi Band - ( By professional artists)",
    label: "Sufi Band - ( By professional artists)",
  },
  { value: "LED Wall - (8x12)", label: "LED Wall - (8x12)" },
  {
    value: "Entry Theme - (According to choice)",
    label: "Entry Theme - (According to choice)",
  },
  {
    value: "Lagan Geet Artist - ( Regional Artists)",
    label: "Lagan Geet Artist - ( Regional Artists)",
  },
  {
    value: "Make-up Artist - (Local professional makeup artist)",
    label: "Make-up Artist - (Local professional makeup artist)",
  },
  {
    value: "Mehendi Artist - (Local professional mehndi artist)",
    label: "Mehendi Artist - (Local professional mehndi artist)",
  },
  {
    value: "Brass Band - (Local brass band with road lights)",
    label: "Brass Band - (Local brass band with road lights)",
  },
  {
    value: "Photographer - ( Professional Photographers)",
    label: "Photographer - ( Professional Photographers)",
  },
  {
    value: "Return Gifts - (According to the choice)",
    label: "Return Gifts - (According to the choice)",
  },
  {
    value: "Cake - (According to the choice)",
    label: "Cake - (According to the choice)",
  },
  {
    value: "Dance Troupe - (6+1 team or by choice)",
    label: "Dance Troupe - (6+1 team or by choice)",
  },
  {
    value: "Transportation - (Local transportation according to demand)",
    label: "Transportation - (Local transportation according to demand)",
  },
  {
    value: "Hospitality Team and Security",
    label: "Hospitality Team and Security",
  },
  {
    value: "Other Entertainment Services can be arranged on demand.",
    label: "Other Entertainment Services can be arranged on demand.",
  },
];

const eventTypeOptions = {
    western: [
      { value: "Engagement Party", label: "Engagement Party" },
      { value: "Bridal Shower", label: "Bridal Shower" },
      { value: "Rehearsal Dinner", label: "Rehearsal Dinner" },
      { value: "Wedding Ceremony", label: "Wedding Ceremony" },
      { value: "Post-Wedding Brunch", label: "Post-Wedding Brunch" },
      { value: "Reception", label: "Reception" },
      { value: "City Tour", label: "City Tour" },
    ],
    hindu: [
      { value: "Haldi", label: "Haldi" },
      { value: "Mehendi", label: "Mehendi" },
      { value: "Sangeet", label: "Sangeet" },
      { value: "Engagement", label: "Engagement" },
      { value: "Tilak", label: "Tilak" },
      { value: "Wedding", label: "Wedding" },
      { value: "Reception", label: "Reception" },
      { value: "City Tour", label: "City Tour" },
    ],
    muslim: [
      { value: "Engagement", label: "Engagement" },
      { value: "Manjha", label: "Manjha" },
      { value: "Mehendi", label: "Mehendi" },
      { value: "Nikah", label: "Nikah" },
      { value: "Walima", label: "Walima" },
      { value: "City Tour", label: "City Tour" },
    ],
    spiritual: [
      {
        value: "Intention-Setting Ceremony / Meditation Circle",
        label: "Intention-Setting Ceremony / Meditation Circle",
      },
      { value: "Cleansing Ritual", label: "Cleansing Ritual" },
      {
        value: "Spiritual Union / Soul Ceremony",
        label: "Spiritual Union / Soul Ceremony",
      },
      {
        value: "Gratitude Dinner / Natural Feast",
        label: "Gratitude Dinner / Natural Feast",
      },
      { value: "City Tour", label: "City Tour" },
    ],
    sikh: [
      { value: "Roka", label: "Roka" },
      { value: "Kurmai", label: "Kurmai" },
      { value: "Chunni", label: "Chunni" },
      { value: "Maiyan", label: "Maiyan" },
      { value: "Mehendi", label: "Mehendi" },
      { value: "Sangeet", label: "Sangeet" },
      { value: "Wedding / Anand Karaj", label: "Wedding / Anand Karaj" },
      { value: "Reception", label: "Reception" },
      { value: "City Tour", label: "City Tour" },
    ],
    jain: [
      { value: "Sagai", label: "Sagai" },
      { value: "Matrika Sthapan", label: "Matrika Sthapan" },
      { value: "Haldi / Pithi", label: "Haldi / Pithi" },
      { value: "Mehendi", label: "Mehendi" },
      { value: "Sangeet", label: "Sangeet" },
      { value: "Wedding", label: "Wedding" },
      { value: "Reception", label: "Reception" },
      { value: "City Tour", label: "City Tour" },
    ],
    buddhist: [
      { value: "Khachang", label: "Khachang" },
      { value: "Wedding", label: "Wedding" },
      { value: "Alms Giving", label: "Alms Giving" },
      {
        value: "Community Meal / Reception",
        label: "Community Meal / Reception",
      },
      { value: "City Tour", label: "City Tour" },
    ],
    kitti: [
      {
        value: "Community Meal / Reception",
        label: "Community Meal / Reception",
      },
      { value: "City Tour", label: "City Tour" },
    ],
    "anniversery-package": [
    { value: "Anniversary", label: "Anniversary" }
  ],

  "birthday-package": [
    { value: "Birthday", label: "Birthday" }
  ],

  "engagement-package": [
    { value: "Engagement", label: "Engagement" },
  ],

}
const packageThemeOption = [
  {
    value: "western",
    label: "Western Style / Christian Wedding"
  },
  {
    value: "hindu",
    label: "Indian Traditional / Hindu Wedding"
  },
  {
    value: "muslim",
    label: "Muslim / Nikah Wedding"
  },
  {
    value: "spiritual",
    label: "Spiritual Wedding"
  },
  {
    value: "sikh",
    label: "Sikh / Anand Karaj Wedding"
  },
  {
    value: "jain",
    label: "Jain Wedding"
  },
  {
    value: "buddhist",
    label: "Buddhist Wedding"
  },
];
const unpluggedOption = [
  {
    value: "bachelor_party",
    label: "Bachelor’s / Bachelorette Party"
  },
  {
    value: "kitty_party",
    label: "Kitty Party",
  },
  {
    value: "college_fests",
    label: "College Fests",
  },
  {
    value: "festive_parties",
    label: "Festive Parties"
  },
  {
    value: "proposal_events",
    label: "Proposal Events"
  },
  {
    value: "suprise_events",
    label: "Suprise Events"
  },
];
const unpluggedEventTypes = {
     bachelor_party: [
      { value: "Bachelor’s Party", label: "Bachelor’s Party" },
      { value: "Bachelorette Party", label: "Bachelorette Party" },
      { value: "City Tour", label: "City Tour" },
    ],
     kitty_party: [
      { value: "Kitty Party", label: "Kitty Party" },
      { value: "City Tour", label: "City Tour" },
    ],
     college_fests: [
      { value: "Cultural Fest", label: "Cultural Fest" },
      { value: "Fresher’s Party", label: "Fresher’s Party" },
      { value: "Farewell Party", label: "Farewell Party" },
    ],
     festive_parties: [
      { value: "Dandiya Night", label: "Dandiya Night" },
      { value: "Holi Milan", label: "Holi Milan" },
      { value: "Halloween Party", label: "Halloween Party" },
      { value: "Christmas Party", label: "Christmas Party" },
      { value: "New Year Party", label: "New Year Party" },
      { value: "Eid Milan", label: "Eid Milan" },
      { value: "Mango Party", label: "Mango Party" }
    ]
}

export { packageIncludesOptions, tandcOptions, addOnsOption, eventTypeOptions,packageThemeOption,unpluggedOption,unpluggedEventTypes };
